import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import SectionContentGrid from './sections/section-content-grid';
import { colors, Container, media } from '../ui-components';

/**
 * Component that renders the groups of awards
 *
 * @component groupAwards
 * 
 * @param {object} awards
 * @param {number} gridSize
 * 
 * @returns {JSX}
 */

const groupAwards = (awards, gridSize) => {
  let awardsLength = awards.gridItems.length;
  let groupedAwards = [];

  for (let i = 0; awardsLength > 0; i++) {
    groupedAwards[i] = awards.gridItems.slice(i * gridSize, i * gridSize + gridSize);
    awardsLength = awardsLength - gridSize;
  }

  /* we want to center awards if less than 3 are present */
  let numAwards = awards.gridItems.length < 3 ? true : false;

  return groupedAwards.map((awardSection, i) => (
    <SectionContentGrid key={i} gridItems={awardSection} imageOnly={true} centerAwardsGrid={numAwards} />
  ));
};

const AwardCarousel = props => {
  const {awards} = props

  const config = {
    showArrows: true,
    showStatus: false,
    showIndicators: false,
    infiniteLoop: true,
    showThumbs: false,
    useKeyboardArrows: true,
    autoPlay: true,
    stopOnHover: true,
    swipeable: true,
    dynamicHeight: false,
    emulateTouch: true,
    interval: 7500,
    transitionTime: 1500
  };

  return (
    <CarouselContainer>
      <DesktopCarousel {...config}>
        {groupAwards(awards, 4)}
      </DesktopCarousel>
      <MobileCarousel {...config}>
        {groupAwards(awards, 2)}
      </MobileCarousel>
    </CarouselContainer>
  );
};

const CarouselContainer = styled(props => <Container {...props} />)`
  position: relative;
  width: 100%;
  padding: 0;
  margin: 0;
  max-width: none;
`;

const DesktopCarousel = styled(props => <Carousel {...props} />)`
  .carousel {
    .control-arrow {
      opacity: .4;
      margin: 0;
      padding: 3px;

      &:hover {
        opacity: 1;
        background: none;
      }
    }

    .control-prev.control-arrow {
      &:before {
        border-right: 8px solid ${colors.crederaRed};
      }
    }

    .control-next.control-arrow {
      &:before {
        border-left: 8px solid ${colors.crederaRed};
      }
    }
  
    .slider {
      .slide {
        height: 200px;
      }
    }

  @media screen and (max-width: ${media.smallTop}) {
    display: none;
  }
`;

const MobileCarousel = styled(props => <Carousel {...props} />)`
  .carousel {
    .control-arrow {
      opacity: .4;
      margin: 0;
      padding: 3px;

      &:hover {
        opacity: 1;
        background: none;
      }
    }

    .control-prev.control-arrow {
      &:before {
        border-right: 8px solid ${colors.crederaRed};
      }
    }

    .control-next.control-arrow {
      &:before {
        border-left: 8px solid ${colors.crederaRed};
      }
    }
  
    .slider {
      .slide {
        max-height: 200px;
      }
    }
  }

  @media screen and (min-width: ${media.smallTop}) {
    display: none;
  }
`;

export default AwardCarousel;
